import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'; // <-- NgModel lives here
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {   MatSidenavModule, MatSliderModule,
  MatSlideToggleModule , MatSidenav, MatDialog, MatDialogModule, MatProgressBar } from '@angular/material';
import { AppComponent } from './app.component';
import { CuestionarioComponent } from './cuestionario/cuestionario.component';
import { DiagnosticoComponent } from './diagnostico/diagnostico.component';
import { SolucionComponent } from './solucion/solucion.component';
import { DiagnosticoService } from './diagnostico.service';
import { CuestionarioService } from './cuestionario.service';
import { NavegacionService } from './sidenav.service';
import { CuestionarioHttpServicesService } from './cuestionario-http-services.service';
import { ErrorInterceptorProvider } from './errorhandler.service';

import { UserService } from './shared/user.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { UserComponent } from './user/user.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { HomeComponent } from './home/home.component';
import { SignUpComponent } from './user/sign-up/sign-up.component';
import { appRoutes } from './routes';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { MenurecursosComponent } from './menurecursos/menurecursos.component';
import { MenucuestionarioComponent } from './menucuestionario/menucuestionario.component';
import { AyudaComponent } from './ayuda/ayuda.component';
import { CongratsComponent } from './congrats/congrats.component';
import { LoaderService } from './loader.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DiagnosticosListaComponent } from './diagnosticos-lista/diagnosticos-lista.component';
import { DiagnosticosEdicionComponent } from './diagnosticos-edicion/diagnosticos-edicion.component';
import { DiagnosticoclienteHttpService } from './diagnosticocliente-http.service';
import { SolucionDocumentComponent } from './solucion-document/solucion-document.component';
import { ForgotPasswordComponent } from './user/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './user/reset-password/reset-password.component';
import { DashboardDiagnosticoComponent } from './dashboard-diagnostico/dashboard-diagnostico.component';
import { ConfirmMailComponent } from './user/confirm-mail/confirm-mail.component';
import { UsuarioEdicionComponent } from './user/usuario-edicion/usuario-edicion.component';
import { ChangePasswordComponent } from './user/change-password/change-password.component';
import { RecaptchaModule, RECAPTCHA_SETTINGS,  RecaptchaSettings,
  RecaptchaLoaderService, } from 'ng-recaptcha';
  import { environment } from '../environments/environment';
import { TarjetacompletaComponent } from './tarjetacompleta/tarjetacompleta.component';
  // Google invisible API Key
const globalSettings: RecaptchaSettings = {siteKey: environment.GOOGLE_INV_CAPTCH};

@NgModule({
  declarations: [
    AppComponent,
    CuestionarioComponent,
    SolucionComponent,
    DiagnosticoComponent,
    MenurecursosComponent,
    MenucuestionarioComponent,
    AyudaComponent,
    CongratsComponent,
    SignUpComponent,
    UserComponent,
    HomeComponent,
    SignInComponent,
    DashboardComponent,
    DiagnosticosListaComponent,
    DiagnosticosEdicionComponent,
    SolucionDocumentComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    DashboardDiagnosticoComponent,
    ConfirmMailComponent,
    UsuarioEdicionComponent,
    ChangePasswordComponent,
    TarjetacompletaComponent
    ],
  entryComponents: [DiagnosticosEdicionComponent],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    MatToolbarModule,
    MatCardModule,
    MatIconModule,
    MatListModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    MatTableModule,
    MatMenuModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    MatDialogModule,
    MatProgressBarModule,
    RecaptchaModule.forRoot(),
    // RouterModule.forRoot(appRoutes)
    RouterModule.forRoot(appRoutes)
  ],
  providers: [DiagnosticoService, CuestionarioService,
    UserService, AuthGuard,
    LoaderService, NavegacionService, CuestionarioHttpServicesService ,
    DiagnosticoclienteHttpService,
    MatDialog,
    MatProgressBar,
    // ErrorInterceptorProvider ,
    {
      provide : HTTP_INTERCEPTORS,
      useClass : AuthInterceptor,
      multi : true
    } ,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: globalSettings,
    }
 ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts